import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import Select from 'react-select';
import Titulo from '../comum/Titulo';
import buscarPrecos from '../../actions/preco/buscarPrecos';
import pesquisarPrecos from '../../actions/preco/pesquisarPorPrecos';
import excluirPrecos from '../../actions/preco/excluirPreco';
import {alterouPagina} from '../../util/filtros';
import {
    getAdminEmpresa,
    getGestorEmpresa,
    getOperadorEmpresa,
    getPerfisVendedores,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import Preco from './Preco'
import ModalCadastrarPreco from './ModalCadastrarPreco';
import {alterouEmpresa} from '../../actions/empresa/alterarEmpresaSelecionada';
import determinaPaginaAtual from '../../actions/preco/determinarPaginaAtualPreco'
import buscarTrechos from '../../actions/trecho/buscarTrechos'
import limparPrecos from '../../actions/preco/limparPrecos'
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoPreco from './PaginacaoPreco';
import BotoesPaginacaoPreco from './BotoesPaginacaoPreco';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import buscarTiposPreco from '../../actions/preco/buscarTiposPreco';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import {estados} from '../../util/constantsUtil';
import {showSuccessMsg} from '../../util/messagesUtil';
import ModalImportarPreco from './ModalImportarPreco';
import {importarPrecos} from '../../actions/preco/cadastrarPreco'
import ModalHistoricoPrecos from './ModalHistoricoPrecos';
import $ from 'jquery';

export const CabecalhoTabela = idEmpresa => (
    <div id="header-tabela" className="lista-table">
        <div className="row cabecalho-desktop">
            <div className="col-lg-3 col-xl-3">Cidade origem</div>
            <div className="col-lg-3 col-xl-3">Cidade destino</div>
            <div className="col-lg-2 col-xl-2">Tipo veículo</div>
            <div className="col-lg-2 col-xl-2">Valor</div>
            <Autorizacao
                perfisPermitidos={[PERFIL_ADMIN,
                    getAdminEmpresa(idEmpresa),
                    getGestorEmpresa(idEmpresa),
                    getOperadorEmpresa(idEmpresa)]}>
                <div className="col-lg-2 col-xl-2">Ações</div>
            </Autorizacao>
        </div>
    </div>
);

const ModalConfirmacaoExclusaoPreco = ({excluir, preco}) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoPreco" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja excluir <strong>{preco ? preco.name : ''}</strong></p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal">Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                            onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class PainelGerenciarPreco extends React.Component {
    constructor(props) {
        super(props);
        this.selecionarPreco = this.selecionarPreco.bind(this);
        this.selecionarTrecho = this.selecionarTrecho.bind(this);
        this.montarParametroPreco = this.montarParametroPreco.bind(this);
        this.limparCampos = this.limparCampos.bind(this);
        this.excluir = this.excluir.bind(this);
        this.abrirModalNovoValor = this.abrirModalNovoValor.bind(this);
        this.state = {
            precoSelecionado: null,
            textoFiltro: null,
            parametros: {},
            tipoPrecoObjSelecionado: null,
            habilitadoPrecoVolta: true
        };
    }

    UNSAFE_componentWillMount() {
        this.props.determinaPaginaAtual(1)
    }

    componentDidMount() {
        this.props.limparPrecos();
        this.props.buscarTiposPreco();
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.buscarPrecos(this.props.empresaSelecionada.id, [], 0, 10);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (alterouEmpresa(this.props, prevProps)
            || alterouPagina(this.props, prevProps)
            || this.state.parametros !== prevState.parametros) {
            this.buscarPrecos();
        }
    }

    limparEmpresaSelecionada() {
        this.setState({precoSelecionado: null});
    }

    buscarPrecos() {        
        this.props.buscarPrecos(this.props.empresaSelecionada.id, this.state.parametros, this.props.paginaAtual, this.props.registrosPorPagina);
    }

    // eslint-disable-next-line class-methods-use-this
    montarParametroPreco(values) {
        return {
            id: values.idPreco,
            cidadeOrigemId: values.cidadeOrigem.value,
            cidadeDestinoId: values.cidadeDestino.value,
            empresaId: this.props.empresaSelecionada.id,
            tipoPreco: values.tipo.value,
            valor: values.valor ? values.valor.replace('R$', '') : null,
            valorAntt: values.valorAntt ? values.valorAntt.replace('R$', '') : null,
            tarifaSeguro: values.tarifaSeguro ? values.tarifaSeguro.replace('R$', '') : null,
            habilitadoPrecoVolta: values.habilitadoPrecoVolta
        };
    }

    selecionarPreco(preco) {
        this.setState({precoSelecionado: preco});
    }

    selecionarTrecho(trecho) {
        this.setState({trechoSelecionado: trecho});
    }

    excluir() {
        this.props.excluirPrecos(this.state.precoSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Valor excluído com Sucesso!');
                this.buscarPrecos();
                this.limparEmpresaSelecionada();
            })
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroPreco',
            'idPreco', '');
        this.props.changeFieldValue('formularioCadastroPreco',
            'origem', '');
        this.props.changeFieldValue('formularioCadastroPreco',
            'destino', '');
        this.props.changeFieldValue('formularioCadastroPreco',
            'trechos', '');
        this.props.limparPrecos()
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotaoNovoPreco() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="text-right">
                            <button onClick={this.abrirModalNovoValor} className="btn btn-laranja">
                                Novo Valor
                            </button>
                        </div>
                    </div>
                </div>
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                    <div>
                        <button data-toggle="modal"
                                data-target="#modalImportarPrecos"
                                className="btn btn-laranja">
                            Importar preços
                        </button>
                    </div>
                </Autorizacao>
            </Autorizacao>)
    }

    exibirTabelaPrecos() {
        if (this.props.precos && this.props.precos.length) {
            return (<div className="col-12 conteudo-internas">
                    <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoPreco}
                                           BotoesPaginacao={BotoesPaginacaoPreco}
                                           precos={this.props.precos}
                                           empresaSelecionada={this.props.empresaSelecionada}>
                        <CabecalhoTabela idEmpresa={this.props.empresaSelecionada.id}/>
                        <div className="lista-table">
                            {this.exibirPrecos()}
                        </div>
                    </CabecalhoRodapeTabela>
                </div>
            )
        }
        return <div>Nenhum preço cadastrado para a empresa selecionada.</div>;
    }

    exibirPrecos() {
        if (this.props.precos) {
            return this.props.precos.map((preco, index) => <Preco idEmpresa={this.props.empresaSelecionada.id}
                                                                  key={index} preco={preco}
                                                                  selecionarPreco={this.selecionarPreco}
                                                                  indice={index}/>)
        }
    }

    adicionarFiltro(filtro) {
        this.props.adicionarFiltroPreco(filtro)
    }

    exibirComboTipoVeiculo(event) {        
        if (!this.props.tiposPreco) {
            return ''
        }
        return (
            <React.Fragment>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    styles={{
                        control: (base, {isDisabled}) => ({
                            ...base,
                            height: 44.25,
                            minHeight: 32,
                            fontSize: 16,
                            width: '100%',
                            borderColor: 'hsl(0,0%,80%)',
                            backgroundColor: isDisabled ? '#e4e7ea' : '#FFF',
                            color: '#5c6873',
                            cursor: 'pointer'
                        })
                    }}
                    placeholder='Tipo veículo'
                    value={this.state.parametros.tipoPreco ? {
                        label: this.state.tipoPrecoObjSelecionado.label,
                        value: this.state.tipoPrecoObjSelecionado.value
                    } : ''}
                    isDisabled={this.state.parametros.tipoPreco}
                    options={this.props.tiposPreco.map(elemento => ({
                        label: elemento.descricaoTipoPreco,
                        value: elemento.tipoPreco
                    }))}
                    onChange={elemento => this.selecionarTipoPreco(elemento)}
                />
            </React.Fragment>
        )
    }

    selecionarDestino(value) {
        this.setState({
            parametros: {
                ...this.state.parametros,
                destino: value
            }
        })
    }

    selecionarOrigem(value) {
        this.setState({
            parametros: {
                ...this.state.parametros,
                origem: value
            }
        })
    }

    selecionarTipoPreco(tipoPreco) {
        this.setState({                
            tipoPrecoObjSelecionado: tipoPreco
        });
        
        this.setState({
            parametros: {
                ...this.state.parametros,
                tipoPreco: tipoPreco ? tipoPreco.value : tipoPreco,
            }
        })
    }

    exibirLimparTipoPreco() {
        if (this.state.parametros.tipoPreco) {
            return <button type="button" className="close" aria-label="Close" style={{color: 'red'}}
                           onClick={() => {
                               this.selecionarTipoPreco('')
                           }
                           }>
                <i className="material-icons">
                    &#xe5cd;
                </i>
            </button>
        }
    }


    exibirCamposBusca() {
        return (<React.Fragment>
            <div className="input-group mb-3 mt-3">
                <div className="col-12 col-sm-3 col-md-3">
                    <Field name='tipoVeiculo' component={this.exibirComboTipoVeiculo.bind(this)}/>
                </div>
                {this.exibirLimparTipoPreco()}
                <div className="col-12 col-sm-4 col-md-4 input-group-prepend">
                    <SelecaoCidadeAutocomplete
                        ehVenda={false}
                        exibeLimpar={this.state.parametros.origem} limpar={this.selecionarOrigem.bind(this)}
                        disabled={this.state.parametros.origem} readOnly={true} nome='pesquisaOrigem'
                        placeholder='Cidade origem' selecionarCidade={this.selecionarOrigem.bind(this)}/>
                </div>

                <div className="col-12 col-sm-4 col-md-4 input-group-prepend">
                    <SelecaoCidadeAutocomplete
                        ehVenda={false}
                        exibeLimpar={this.state.parametros.destino} limpar={this.selecionarDestino.bind(this)}
                        disabled={this.state.parametros.destino} nome='pesquisaDestino' placeholder='Cidade destino'
                        selecionarCidade={this.selecionarDestino.bind(this)}/>
                </div>

            </div>
        </React.Fragment>)
    }

    abrirModalNovoValor() {
        this.setState({ habilitadoPrecoVolta: true }, () => {
            $('#modalCadastrarPreco').modal('show');
        });
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                ...getPerfisVendedores(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Valores" urlRetorno="/menu-preco"/>
                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                                <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                                    <li className="nav-item dropdown nome-empresa">
                                        <div className='col-md-6'>
                                            <CampoSelecionarEmpresa/>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </Autorizacao>
                        {this.exibirCamposBusca()}
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            {this.exibirBotaoNovoPreco()}
                            {this.exibirTabelaPrecos()}
                        </div>
                    </div>
                    <ModalImportarPreco
                      empresas={this.props.empresas}
                      buscarPrecos={this.props.buscarPrecos}
                      codigoEmpresaSelecionada={this.props.empresaSelecionada.id}
                      importarPrecos={this.props.importarPrecos}
                      tiposPreco={this.props.tiposPreco}/>
                    <ModalCadastrarPreco
                        estados={estados}
                        parametros={this.state.parametros}
                        montarParametroPreco={this.montarParametroPreco}
                        habilitadoPrecoVolta={this.state.habilitadoPrecoVolta}
                    />
                    <ModalConfirmacaoExclusaoPreco excluir={this.excluir} preco={this.state.precoSelecionado}/>
                    <ModalHistoricoPrecos />
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => (
    {
        precos: state.precoPaginacao.precos,
        empresas: state.empresas,
        changeFieldValue,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualPreco,
        registrosPorPagina: state.registrosPorPaginaPreco,
        tiposPreco: state.tiposPreco,
        tipoVeiculoSelecionado: state.tipoVeiculoSelecionado,
    });


export default connect(mapStateToProps, {
    buscarPrecos,
    excluirPrecos,
    determinaPaginaAtual,
    buscarTrechos,
    pesquisarPrecos,
    limparPrecos,
    selecionarDestino,
    selecionarOrigem,
    buscarTiposPreco,
    importarPrecos
})(reduxForm({
    form: 'formularioCadastroPreco'
})(PainelGerenciarPreco))
